export const normalizeTask = (task) => {
  const rawProgress = task?.progress_percentage ?? task?.progress;
  const numericProgress = Number(rawProgress);
  const progress = rawProgress !== null && rawProgress !== undefined && rawProgress !== '' && Number.isFinite(numericProgress)
    ? Math.min(100, Math.max(0, numericProgress))
    : null;
  return {
    ...task,
    filename: String(task?.filename || task?.name || 'Untitled task').replace(/^(project_document_upload:\d+:\d+:|document_upload:\d+:)/, ''),
    status: String(task?.status || 'pending').toLowerCase(),
    progress,
    progress_percentage: progress,
  };
};

export const taskStatusLabel = (task) => {
  if (task?.recovery_state === 'publication_unknown') return 'Waiting for confirmation';
  if (task?.recovery_state === 'queued') return 'Queued for recovery';
  if (/cancelled by user|cancelado por el usuario/i.test(task?.current_step || '')) return 'Cancelled';
  const labels = {
    pending: 'Queued', queued: 'Queued', processing: 'Processing',
    translating: 'Translating', analyzing: 'Analyzing', running: 'Processing',
    failed: 'Processing stopped', completed: 'Completed', cancelled: 'Cancelled',
  };
  return labels[task?.status] || 'Waiting for update';
};

export const taskStageLabel = (task) => {
  if (task?.recovery_state === 'publication_unknown') return 'Waiting for confirmation';
  const step = String(task?.current_step || '').trim();
  const glossary = step.match(/^Filtering glossary batch (\d+): (\d+)\/(\d+)/i);
  if (glossary) return `Preparing translation (batch ${glossary[1]}, ${glossary[2]}/${glossary[3]})`;
  if (/Restored PDF page checkpoint/i.test(step)) return 'Continuing saved extraction';
  if (/Propagating translated fields/i.test(step)) return 'Saving translated content';
  if (/Queued in Celery/i.test(step)) return 'Queued';
  return step || (task?.status === 'pending' ? 'Queued' : 'Waiting for update');
};

export const taskActivityLabel = (task, now = Date.now()) => {
  const timestamp = task?.last_activity_at || task?.heartbeat_at || task?.updated_at;
  const parsed = Date.parse(timestamp || '');
  if (!Number.isFinite(parsed)) return null;
  const minutes = Math.max(0, Math.floor((now - parsed) / 60000));
  return minutes < 1 ? 'Updated just now' : `Last update ${minutes} min ago`;
};

export const canResumeTask = (task) => (
  task?.can_resume === true
  && task?.status === 'failed'
  && !task?.recovery_state
  && !/cancelled|cancelado|revoked/i.test(task?.current_step || '')
);